import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
const { Content } = Layout;

const contentStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: 'rgba(0, 158, 247, 0.05)',
};
const layoutStyle = {
  height: '100vh',
  overflow: 'hidden',
  width: '100%',
};
const SalesTemplate = () => {
  return (
    <>
      <Layout style={layoutStyle}>
        <Content style={contentStyle}>
          <Outlet />
        </Content>
      </Layout>
    </>
  );
};

export default SalesTemplate;
